(() => {
  const labels = JSON.parse(document.getElementById('ExperienceLabels')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const cartPanel = document.getElementById('CartPanel');
  let openingCart = null;
  async function openCart(trigger) {
    if (!cartPanel) return false;
    if (openingCart) return openingCart;
    if (!cartPanel.open) {
      document.querySelectorAll('.mobile-nav[open],.nav-dropdown[open]').forEach(menu => {menu.open=false;});
      cartPanel.showModal();
      document.documentElement.classList.add('cart-panel-open');
    }
    cartPanel.dataset.loading = 'true';
    cartPanel.querySelector('[data-cart-panel-body]').hidden=false;
    cartPanel.querySelector('[data-cart-panel-body]').setAttribute('aria-busy','true');
    cartPanel.querySelector('[data-cart-panel-body]').setAttribute('inert','');
    cartPanel.querySelector('.cart-panel-fallback').hidden=true;
    const run = async () => {
      try {
        const cart = cartPanel.querySelector('otakiro-cart');
        await customElements.whenDefined('otakiro-cart');
        if (cart.sending || cart.pending) return true;
        await cart.refresh();
        cart.failed=false;
        cart.querySelector('[data-cart-retry]').hidden=true;
        cart.message('',true);
        cart.lock(false);
        return true;
      } catch {
        cartPanel.querySelector('[data-cart-panel-body]').hidden=true;
        cartPanel.querySelector('.cart-panel-fallback').hidden=false;
        return true;
      } finally {
        delete cartPanel.dataset.loading;
        cartPanel.querySelector('[data-cart-panel-body]').removeAttribute('aria-busy');
        cartPanel.querySelector('[data-cart-panel-body]').removeAttribute('inert');
        openingCart=null;
      }
    };
    openingCart=run();
    return openingCart;
  }
  if (cartPanel) {
    document.querySelectorAll('.cart-link').forEach(link => {link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','CartPanel');});
    cartPanel.addEventListener('close',() => {document.documentElement.classList.remove('cart-panel-open');});
    cartPanel.addEventListener('click',event => {
      if (event.target.closest('.cart-continue')) {event.preventDefault();cartPanel.close();}
    });
    document.addEventListener('click',event => {
      const link=event.target.closest('.cart-link');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openCart(link);
    });
  }
  document.addEventListener('otakiro:cart:added', event => {
    if (!cartPanel) return;
    event.preventDefault();
    openCart(event.target.querySelector('[data-bundle-submit]'));
  });
  function init(scope = document) {
    scope.querySelectorAll('[data-directory]').forEach(directory => {
      if (directory.dataset.ready) return;
      directory.dataset.ready = 'true';
      const input = directory.querySelector('[data-directory-search]');
      const cards = [...directory.querySelectorAll('[data-directory-card]')];
      const normalize = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      input.addEventListener('input', () => {
        let count = 0;
        cards.forEach(card => { card.hidden = !normalize(card.dataset.title).includes(normalize(input.value.trim())); if (!card.hidden) count++; });
        directory.querySelector('[data-directory-empty]').hidden = count !== 0;
        directory.querySelector('[data-directory-status]').textContent = input.value ? `${count} / ${cards.length}` : '';
      });
    });
    scope.querySelectorAll('input.quantity').forEach(input => {
      if (input.closest('.quantity-control')) return;
      const wrap = document.createElement('div'); wrap.className = 'quantity-control';
      input.before(wrap); wrap.append(input);
      [-1, 1].forEach(direction => {
        const button = document.createElement('button'); button.type = 'button';
        button.textContent = direction < 0 ? '−' : '+';
        button.setAttribute('aria-label', direction < 0 ? labels.decrease : labels.increase);
        button.addEventListener('click', () => { direction < 0 ? input.stepDown() : input.stepUp(); input.dispatchEvent(new Event('change', {bubbles:true})); });
        direction < 0 ? wrap.prepend(button) : wrap.append(button);
      });
    });
    scope.querySelectorAll('[data-predictive-form]').forEach(form => {
      if (form.dataset.ready) return; form.dataset.ready = 'true';
      const input = form.querySelector('input[type=search]'); const panel = form.querySelector('[data-predictive-panel]');
      let timer, controller, sequence = 0;
      const close = () => {panel.hidden=true;input.setAttribute('aria-expanded','false');};
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort(); sequence++; const current=sequence;
        if(input.value.trim().length<2){close();return;}
        timer=setTimeout(async()=>{
          controller=new AbortController();
          const url=new URL(form.dataset.endpoint,location.origin);
          url.search=new URLSearchParams({q:input.value.trim(),'resources[type]':'product,collection','resources[limit]':'5',section_id:'predictive-search'});
          try{
            const response=await fetch(url,{signal:controller.signal}); if(!response.ok)throw new Error();
            const html=new DOMParser().parseFromString(await response.text(),'text/html');
            if(current!==sequence)return;
            const results=html.querySelector('[data-predictive-results]');
            if(results){panel.replaceChildren(results);panel.hidden=false;input.setAttribute('aria-expanded','true');}
          }catch(error){if(error.name!=='AbortError')close();}
        },250);
      });
      form.addEventListener('keydown',event=>{if(event.key==='Escape')close();if(event.key==='ArrowDown'&&!panel.hidden){event.preventDefault();panel.querySelector('a,button')?.focus();}});
      document.addEventListener('click',event=>{if(!form.contains(event.target))close();});
    });
    scope.querySelectorAll('[data-product-form]').forEach(form=>{
      if(form.dataset.ready)return;form.dataset.ready='true';
      form.addEventListener('submit',async event=>{
        const submitter=event.submitter;if(!submitter?.matches('[data-buy]'))return;
        event.preventDefault();if(!form.reportValidity())return;
        const status=form.closest('[data-product]').querySelector('[data-product-status]');
        const button=form.querySelector('[data-buy]');button.disabled=true;form.setAttribute('aria-busy','true');status.textContent='';
        try{
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const result=await response.json();if(!response.ok)throw new Error(result.description||labels.error);
          status.textContent=labels.added;
          await openCart(button);
        }catch(error){status.textContent=error.message||labels.error;}
        finally{button.disabled=false;form.removeAttribute('aria-busy');}
      });
    });
    scope.querySelectorAll('[data-recommendations]').forEach(element=>{
      if(element.dataset.ready)return;element.dataset.ready='true';
      const observer=new IntersectionObserver(async entries=>{
        if(!entries.some(e=>e.isIntersecting))return;observer.disconnect();
        try{const response=await fetch(element.dataset.url);if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html');const content=doc.querySelector('[data-recommendations]');if(content)element.innerHTML=content.innerHTML;}catch{}
      },{rootMargin:'200px'});observer.observe(element);
    });
  }
  const imageZoom = document.getElementById('ImageZoom');
  let imageZoomVersion = 0;
  let imageZoomTrigger = null;
  imageZoom?.addEventListener('pointerdown', () => { imageZoom.dataset.inputMode = 'pointer'; });
  imageZoom?.addEventListener('keydown', event => {
    if (['Tab', 'Escape', 'Enter', ' '].includes(event.key)) imageZoom.dataset.inputMode = 'keyboard';
  });
  imageZoom?.addEventListener('close', () => {
    imageZoomVersion++;
    const trigger = imageZoomTrigger;
    const pointerInteraction = imageZoom.dataset.inputMode === 'pointer';
    imageZoomTrigger = null;
    delete imageZoom.dataset.inputMode;
    if (pointerInteraction && document.activeElement === trigger) trigger.blur();
  });
  function openImageZoom(link, inputMode = 'keyboard') {
    if (!imageZoom) return;
    const image = imageZoom.querySelector('img');
    if (!image) return;
    imageZoomTrigger = link;
    imageZoom.dataset.inputMode = inputMode;
    const source = link.querySelector('img');
    const preview = source?.currentSrc || source?.src || '';
    const version = ++imageZoomVersion;
    const ratio = (source?.naturalWidth || source?.width || 1) / (source?.naturalHeight || source?.height || 1);
    imageZoom.style.setProperty('--zoom-ratio', ratio);
    const fitWidth = Math.max(1, Math.min(1200, window.innerWidth - 32, (window.innerHeight - 32) * ratio));
    const pixels = fitWidth * Math.min(window.devicePixelRatio || 1, 2);
    const width = [540, 750, 1000, 1200, 1600, 2000].find(value => value >= pixels) || 2000;
    const full = new URL(link.href, location.href);
    const shopifyImage = full.hostname === 'cdn.shopify.com' || full.pathname.startsWith('/cdn/shop/');
    const previewWidth = preview ? Number(new URL(preview, location.href).searchParams.get('width')) || 0 : 0;
    const loadedWidth = Math.max(source?.naturalWidth || 0, shopifyImage ? previewWidth : 0);
    if (shopifyImage) full.searchParams.set('width', width);
    image.decoding = 'async';
    image.alt = source?.alt || '';
    image.src = preview || full.href;
    if (!imageZoom.open) imageZoom.showModal();
    if (preview === full.href || (shopifyImage && source?.complete && loadedWidth >= width)) return;
    const detailed = new Image();
    detailed.decoding = 'async';
    detailed.onload = () => {
      if (version === imageZoomVersion && imageZoom.open) image.src = detailed.src;
    };
    detailed.src = full.href;
  }

  function zoomFeedback(control, action) {
    if (control.hasAttribute('data-zoom-feedback')) return;
    control.setAttribute('data-zoom-feedback', '');
    window.setTimeout(() => {
      if (control.isConnected) action();
      control.removeAttribute('data-zoom-feedback');
    }, 150);
  }
  document.addEventListener('click',event=>{
    const zoom=event.target.closest('[data-zoom]');
    if(zoom){event.preventDefault();if(event.detail === 0)openImageZoom(zoom, 'keyboard');else zoomFeedback(zoom, () => openImageZoom(zoom, 'pointer'));}
    const close=event.target.closest('[data-close-dialog]');if(close){const dialog=close.closest('dialog');if(dialog===imageZoom && event.detail !== 0)zoomFeedback(close, () => {if(dialog.open)dialog.close();});else dialog.close();}
    if(event.target === imageZoom){imageZoom.close();return;}
    if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}
  });
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('otakiro:product:updated',event=>init(event.target));
})();




